// extracted by mini-css-extract-plugin
export var images = "showcase-image-double-module--images--1tFKw";
export var image = "showcase-image-double-module--image--2JKG5";